import { Product, ProductFilter, ProductSort } from 'types/schema';

export interface IHomePreloadTopShowcase {
  sectionKey: string;
  data: Product[];
  basePage: number;
  totalPages: number;
  sort: ProductSort[];
  filter: ProductFilter;
  sectionId?: string | null;
}

export interface IHomePreload {
  region: string;
  lang: string;
  seed: number;
  topShowcase?: IHomePreloadTopShowcase;
}

let consumed = false;

export function readHomePreload(region: string, lang: string, sectionKey: string): IHomePreload | null {
  if (consumed) {
    return null;
  }

  try {
    const preload: IHomePreload | undefined = (window as any).__PRELOADED_STATE__?.homePage;

    if (!preload || !preload.topShowcase?.data?.length) {
      return null;
    }

    if (preload.topShowcase.sectionKey !== sectionKey) {
      return null;
    }

    if (preload.region !== region || preload.lang !== lang) {
      return null;
    }

    consumed = true;

    return preload;
  } catch {
    return null;
  }
}

export function resetHomePreloadForTest(): void {
  consumed = false;
}

export function mergePreservingOrder(current: Product[], fresh: Product[]): Product[] {
  if (!fresh?.length) {
    return current;
  }

  const freshById = new Map<string, Product>();

  fresh.forEach((p) => {
    if (p?.id) {
      freshById.set(p.id, p);
    }
  });

  const merged = current
    .map((p) => {
      const hydrated = p?.id ? freshById.get(p.id) : undefined;
      return hydrated ? { ...p, ...hydrated } : undefined;
    })
    .filter((p): p is Product => !!p);

  const seen = new Set(merged.map((p) => p.id));

  fresh.forEach((p) => {
    if (p?.id && !seen.has(p.id)) {
      merged.push(p);
    }
  });

  return merged;
}
